import { track } from "~/modules/analytics/track";
import { LeagueTableUserEvents } from "~/modules/analytics/events/leagueTable";

// // // //

/**
 * trackLeagueTableTabChange
 * Tracks the event when a user changes a tab in the LeagueTable component
 */
export function trackLeagueTableTabChange(props: {
    prev: string;
    next: string;
    table: string;
}) {
    track(LeagueTableUserEvents.ChangeTab, props);
}

/**
 * trackLeagueTableLoginCtaOpen
 * Tracks the event when a user opens the LoginRequiredModal in the Time Series Visualization controls
 */
export function trackLeagueTableLoginCtaOpen(selectedTabKey: string) {
    track(LeagueTableUserEvents.LoginCtaOpen, {
        leageTableKey: selectedTabKey,
    });
}

/**
 * trackLeagueTableLoginCtaClose
 * Tracks the event when a user closes the LoginRequiredModal in the Time Series Visualization controls
 */
export function trackLeagueTableLoginCtaClose() {
    track(LeagueTableUserEvents.LoginCtaClose);
}

/**
 * trackLeagueTableLoginCtaConfirmed
 * Tracks the event when a user clicks the login button in the LoginRequiredModal in the Time Series Visualization controls
 */
export function trackLeagueTableLoginCtaConfirmed() {
    track(LeagueTableUserEvents.LoginCtaConfirmed);
}
